// Third Party
import * as React from 'react';

// Utils
import {
  SearchPageContentForUrlPathAndTypeQuery,
  SearchRegionForListingsByPlaceNameWithSingleAssetQuery,
} from '@gql';
import { useAnalytics } from '@contexts/use-analytics';

// UI
import { SeoSearchList } from './seo-search-list/seo-search-list';

type SearchPageContentFindByPlaceNameQueryResults = NonNullable<
  SearchPageContentForUrlPathAndTypeQuery['searchPageContentForUrlPathAndType']
>;

type SearchPageContentFindByPlaceNameQueryResultsType<
  T extends SearchPageContentFindByPlaceNameQueryResults['__typename'],
> = SearchPageContentFindByPlaceNameQueryResults & { __typename: T };

export type SearchPageContentPartial =
  SearchPageContentFindByPlaceNameQueryResultsType<'SearchPageContent'>;

type Props = {
  searchPageContent?: SearchPageContentPartial;
  regionDataEntries: SearchRegionForListingsByPlaceNameWithSingleAssetQuery['regionListingsCollection']['entries'];
};

export const SeoSerpPage: React.FC<Props> = ({
  searchPageContent,
  regionDataEntries,
}) => {
  const { setListings } = useAnalytics();

  React.useEffect(() => {
    setListings(regionDataEntries);
  }, [regionDataEntries]);

  return (
    <SeoSearchList
      searchPageContent={searchPageContent}
      regionDataEntries={regionDataEntries}
    />
  );
};
